import { createReducer } from '@reduxjs/toolkit';
import { ITicker } from '@kattana-io/common';
import {
  ADD,
  CHANGE_PRIMARY_TICKER,
  CHANGE_TICKER,
  CHANGE_TICKERS_EXCHANGE,
  IAddPayload,
  IChangePrimaryTickerPayload,
  IChangeTickerPayload,
  ICHangeTickersExchangePayload,
  ISwitchPrimaryPayload,
  SWITCH_PRIMARY,
} from '../actions/grid';
import { StorageKeys } from '../helpers/localStorage';

export interface IGridItem {
    key: string;
    ticker: ITicker;
    primary: boolean;
    exchange: string;
}

export interface IGridNet {
  [key: string]: IGridItem;
}

export interface IGridState {
    net: IGridNet,
    rows: number[];
    cols: number[];
}

export interface IAction<T> {
  type: string;
  payload: T
}

export const defaultState = {
  net: {},
  rows: [1],
  cols: [1],
} as IGridState;

const gridState = createReducer(defaultState, (builder: any) => {
  builder
    .addCase(ADD, (state: IGridState, {payload}: IAction<IAddPayload>) => {
      state.net = payload.net;
      state.cols = payload.cols;
      state.rows = payload.rows;
    })
    .addCase(SWITCH_PRIMARY, (state: IGridState, {payload}: IAction<ISwitchPrimaryPayload>) => {
      Object.keys(state.net).forEach((k: string) => {
        if (k === payload.newPrimaryKey) {
          state.net[k].primary = true;
        } else {
          state.net[k].primary = false;
        }
      });
    })
    .addCase(CHANGE_TICKER, (state: IGridState, {payload}: IAction<IChangeTickerPayload>) => {
      state.net[payload.key].ticker = payload.ticker;
    })
    .addCase(CHANGE_PRIMARY_TICKER, (state: IGridState, {payload}: IAction<IChangePrimaryTickerPayload>) => {
      const primaryTicker = Object.values(state.net).find(t => t.primary);
      if (primaryTicker) {
        state.net[primaryTicker.key].ticker = payload.ticker;
        state.net[primaryTicker.key].exchange = payload.exchange;
      }
    })
    .addCase(CHANGE_TICKERS_EXCHANGE, (state: IGridState, {payload}: IAction<ICHangeTickersExchangePayload>) => {
      state.net[payload.tickerKey].exchange = payload.exchange;
    })
    .addDefaultCase((state: IGridState, action: any) => {});
});

const saveState = (state: IGridState) => {
  localStorage.setItem(StorageKeys.grid, JSON.stringify(state));
  return state;
};

export default gridState;
